import Onboarding from "../../../../components/company/workforce/onboarding"

const OnBoardingPage = () => {
    return <Onboarding/>
}

export default OnBoardingPage;